import React, { useContext, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import {
  makeStyles, Box, LinearProgress, Typography,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import AppContext from '../../state/AppContext';
import { fetchStaticToken } from '../../helpers/authentication';
import api from '../../config/api';
import FollowUp from './FollowUp';
import { isLoadingRegionsState } from '../../state/apiRequestStatus';
import { jwtTokenState, validatedCustomerState } from '../../state/apiData';

const useStyles = makeStyles(() => ({
  container: {},
}));

const FollowUps = () => {
  const classes = useStyles();
  const {
    isLoadingServices,
    isLoadingTherapists,
  } = useContext(AppContext);

  const jwtToken = useRecoilValue(jwtTokenState);
  const validatedCustomer = useRecoilValue(validatedCustomerState);
  const isloadingRegions = useRecoilValue(isLoadingRegionsState);

  const [isLoadingFollowups, setIsLoadingFollowups] = useState(false);
  const [errorFollowUps, setErrorFollowUps] = useState(false);
  const [followUps, setFollowUps] = useState(null);

  const fetchFollowUps = async () => {
    setIsLoadingFollowups(true);
    setErrorFollowUps(false);

    const responseFollowUps = await fetchStaticToken({
      url: api.followUps,
      method: 'POST',
      body: {
        email: validatedCustomer.email,
        customerID: validatedCustomer.customerID,
        jwt: jwtToken,
      },
    });

    if (responseFollowUps.status === 200) {
      const responseFollowUpsData = await responseFollowUps.json();
      setFollowUps(responseFollowUpsData);
      return setIsLoadingFollowups(false);
    }

    setErrorFollowUps(true);
    return setIsLoadingFollowups(false);
  };

  useEffect(() => {
    fetchFollowUps();
  }, []);

  return (
    <div className={classes.container}>
      <Box mt={3} mb={2}>
        <Typography variant="h3">
          <FormattedMessage id="FollowUpAppointments.mainTitle" />
        </Typography>
      </Box>
      {errorFollowUps
        && (
          <Box mt={3}>
            <Alert severity="error">
              <FormattedMessage id="FollowUpAppointments.emptyArrayResponse" />
            </Alert>
          </Box>
        )}

      {errorFollowUps
      || !(isLoadingFollowups || isLoadingServices || isLoadingTherapists || isloadingRegions)
        ? (followUps && followUps.map((followUp) => (
          <FollowUp followUp={followUp} key={followUp.id} />)))
        : <LinearProgress />}
    </div>
  );
};

FollowUps.propTypes = {};

export default FollowUps;
